import React, { useRef, useState } from "react";
import {
  FieldInputPercentage,
  CsplTable as Table,
  FieldInput,
  FieldInputNumber,
} from "../../../components";
import { Formik, Field, FieldArray } from "formik";
import { Form } from "react-bootstrap";
import { isEmpty, get } from "lodash";
import { useDeepEffect } from "../../../abstracts";
const onFormSubmit = () => {};

function SetPercentageSlideout(props) {
  const {
    title = "",
    data = [],
    handleChange,
    values,
    setFieldValue,
    tableError,
  } = props;
  const [total, setTotal] = useState(0);
  useDeepEffect(() => {
    var tot = values.beneficiaryPercentage.reduce(
      (ini, x) =>
        [undefined, null, "", NaN].includes(x.percentage)
          ? 0 + ini
          : x.percentage + ini,
      0
    );
    setTotal(tot);
  }, [values.beneficiaryPercentage]);
  return (
    <div style={{ marginTop: "30px" }}>
      <FieldArray name="beneficiaryPercentage">
        {(fieldArrayProps) => {
          return (
            <Table>
              <Table.Thead>
                <Table.Tr>
                  {[
                    {
                      label: (
                        <div style={{ fontSize: "16px" }}>
                          {title} - {data.length}{" "}
                        </div>
                      ),
                    },
                    { label: "" },
                  ].map((item, index) => {
                    return <Table.Th key={index}>{item.label}</Table.Th>;
                  })}
                </Table.Tr>
              </Table.Thead>
              <Table.Tbody>
                {data.map((bene, index) => {
                  const fieldName = `beneficiaryPercentage.${index}.percentage`;
                  const AddBenefeciaryId = (e) => {
                    setFieldValue(
                      `beneficiaryPercentage.${index}.beneficiaryId`,
                      bene.id
                    );
                    setFieldValue(fieldName, parseFloat(e.target.value));
                  };
                  return (
                    <Table.Tr
                      style={{ display: "flex", padding: "25px 0px" }}
                      key={index}
                    >
                      <Table.Td className="w-75">
                        <div>
                          <div
                            style={{
                              color: "blue",
                              fontSize: "16px",
                              fontWeight: "500",
                              marginBottom: "7px",
                            }}
                          >
                            {get(bene, "name", "")}
                          </div>
                          <div>
                            Relationship :{" "}
                            <span style={{ fontWeight: "500" }}>
                              {" "}
                              {get(bene, "relationship", "")}
                            </span>
                          </div>
                        </div>
                      </Table.Td>
                      <Table.Td className="w-15">
                        <Field
                          isRequired
                          name={fieldName}
                          type="number"
                          max={100}
                          autoComplete="off"
                          value={get(values, fieldName)}
                          onChange={(e) => {
                            AddBenefeciaryId(e);
                          }}
                          component={FieldInputPercentage}
                          size="xxs"
                        />
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
              </Table.Tbody>
            </Table>
          );
        }}
      </FieldArray>
      <div className="percentageErrorMessage">{tableError}</div>
      <div
        style={{
          width: "95%",
          display: "flex",
          justifyContent: "space-between",
          fontWeight: "600",
          fontSize: "16px",
          marginTop: "30px",
        }}
      >
        <div>Total {title} Percentage</div>
        <div className="ms-auto">{total}%</div>
      </div>
    </div>
  );
}

export default SetPercentageSlideout;
